import { render, staticRenderFns } from "./OverviewView.vue?vue&type=template&id=6ac76a66"
import script from "./OverviewView.vue?vue&type=script&lang=ts"
export * from "./OverviewView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports